module.exports = __webpack_public_path__ + "img/Patch3.2-20170717.dc3a638c.webp";